module.exports = __webpack_public_path__ + "img/449-7ec449.png";